<template>
  <div class="align-center d-flex justify-center loader position-absolute w-100">
    <loader />
  </div>
</template>

<script setup lang="ts">
import Loader from './Loader.vue';
</script>
